import * as S from './styles';
import VisaLogo from '../../../assets/images/visa.svg'
import QISignTheme from '../../../interfaces/Theme';

declare type CreditCardProps = {
    title?: string;
    cardLabel?: string;
    type?: string;
    clientThemeSettings: QISignTheme;
}

export default function CreditCard({ title, cardLabel, type, clientThemeSettings }: CreditCardProps) {
    const backgroundColor = clientThemeSettings.background_color;
    const buttonColor = clientThemeSettings.button_color;

    const color = type === 'secondary' ? buttonColor : backgroundColor;

    return (
        <S.Container>
            <S.CreditCardContainer $theme={color}>
                <S.Header>
                    <S.CardTitle>{cardLabel ?? 'Crédito'}</S.CardTitle>
                    <S.BrandIcon src={VisaLogo} alt="Visa" />
                </S.Header>

                <S.NumberRow>
                    <S.MaskedNumber>* * * *  * * * *  * * * *  * * * * </S.MaskedNumber>
                </S.NumberRow>

                <S.HolderName>{title}</S.HolderName>
            </S.CreditCardContainer>
        </S.Container>
    )
}